import { SearchFile } from 'owa-search-service/lib/data/schema/SubstrateSearchResponse';

export default interface TabbedSearchStore {
    activeSearchTab?: SearchTab;
    fileSearchResults: SearchFile[];
    loadingState: TabbedSearchLoadingState;
}

export enum SearchTab {
    All = 'All',
    Mail = 'Mail',
    Files = 'Files',
}

export enum TabbedSearchLoadingState {
    NotStarted,
    InProgress,
    Complete,
    Error,
}
